import { IAddress } from "common/types";

import { useCurrentDrawer } from "client/common/hooks/stackables";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";

import AddressDrawerForm from "../forms/AddressDrawerForm";

const noop = () => undefined;

export type CreateAddressDrawerProps = {
  onSuccess?: (address: IAddress) => void;
  shouldUpdatePrimary?: boolean;
  displaySubscriptionsBulkUpdate?: boolean;
};

const CreateAddressDrawer = ({
  onSuccess = noop,
  shouldUpdatePrimary = false,
  displaySubscriptionsBulkUpdate = false,
}: CreateAddressDrawerProps) => {
  const { close } = useCurrentDrawer();

  const handleSuccess = (address: IAddress) => {
    close();
    onSuccess(address);
  };

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Add address" onClose={close} />
      <AddressDrawerForm
        isPrimary={shouldUpdatePrimary}
        onSuccess={handleSuccess}
        displaySubscriptionsBulkUpdate={displaySubscriptionsBulkUpdate}
      />
    </DrawerLayout>
  );
};

export default CreateAddressDrawer;
